import { use, useMemo } from "react";
import type { SortingOptions } from "types";

import { TranslationContext } from "@app/_context/translationContext";

export default function useSortingOptions() {
  const translations = use(TranslationContext);

  return useMemo<SortingOptions>(() => {
    return Object.entries(translations ?? {})
      .filter(([key]) => key.startsWith("sort_"))
      .map(([key, label]) => ({
        id: key.slice(5),
        label: label ?? key,
      })) as SortingOptions;
  }, [translations]);
}
